
define('hbs!glu/grid/filter/manageFiltersLink.hbs',['hbs','handlebars'], function(hbs, Handlebars){var t = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<li class=\"selectable\"><a href=\"#\" class=\"btn btn-tertiary grid-manage-filters-link-btn\">"
    + this.escapeExpression((helpers.locale || (depth0 && depth0.locale) || helpers.helperMissing).call(depth0,"manageFilters",{"name":"locale","hash":{},"data":data}))
    + "</a></li>";
},"useData":true});Handlebars.registerPartial('glu/grid/filter/manageFiltersLink.hbs', t);return t;});
